import { getSectionsScreenshots } from '../../../../features/components/PdfGeneration/generatePdfReport'
import { getSectionSplitByPage } from '../../../../features/components/PdfGeneration/generatePdfReport/contentPreparation'
import { cleanUpTemporaryPDFElements, processVideos } from '../../../../helpers/pdf'

import { CARD_LIST_ITEM_CLASSNAME } from '../../../../constants/pdf'

export const getReportPDFSections = async brandColor => {
  const facebookSocialPostsSection = getSectionSplitByPage(
    '#facebook-social-posts-list',
    `[class^="${CARD_LIST_ITEM_CLASSNAME}"]`,
    3,
    newUl => processVideos(newUl, brandColor)
  )

  const instagramSocialPostsSection = getSectionSplitByPage(
    '#instagram-social-posts-list',
    `[class^="${CARD_LIST_ITEM_CLASSNAME}"]`,
    3,
    newUl => processVideos(newUl, brandColor)
  )

  // todo implement twitter when it's ready
  // const twitterSocialPostsSection = getSectionSplitByPage(
  //   '#twitter-social-posts-list',
  //   `[class^="${CARD_LIST_ITEM_CLASSNAME}"]`,
  //   3,
  //   newUl => processVideos(newUl, brandColor)
  // )

  const sections = [
    ...facebookSocialPostsSection,
    ...instagramSocialPostsSection
    // ...twitterSocialPostsSection
  ]

  // create screenshots for each section
  const content = await getSectionsScreenshots(sections)
  // clean up all temporary elements with ".temporary-pdf-wrapper" class
  cleanUpTemporaryPDFElements()

  return content
}
